<template>
	<div class="courseCollect ">
		<div class="" v-if="isFinish&&dataList.length>0">
			<div class="" style="min-height: 500px;">
				<div @click="goUrl(item,index)"
					class="cursor-pointer flex items-center justify-between p-[20px] box-border"
					v-for="(item,index) in dataList" :key="index">
					<div class="flex-1 flex items-center mr-[60px]">
						<el-image class="w-[162px] h-[108px] mr-[14px] rounded-[6px]" :src="item.info.image"
							fit="cover"></el-image>
						<div class="flex-1">
							<div class="text-[16px] text-[#101010] yw-text-cut-1 font-bold mb-[6px]">
								{{item.info.title}}
							</div>
							<div class="text-[14px] text-[#A6A6A6] yw-text-cut-1 mb-[20px]">
								{{item.info.subtitle}}
							</div>
							<div class="flex items-center text-[14px] text-[#686C73]">
								<img src="@/static/image/icon58.png" class="w-[20px] h-[20px] mr-[4px]" alt="" />
								{{item.create_time}}
							</div>
						</div>
					</div>
					<div @click.stop="cancelCollect(item,index)"
						class="w-[91px] h-[34px] leading-[34px] cursor-pointer text-center text-white bg-[#FF0000] text-[14px] rounded-[4px]">
						{{langInfo.cancel_collect}}
					</div>
				</div>
			</div>
			<div class="flex justify-center">
				<el-pagination :page-size="limit" :total="total" :current-page="page" @current-change="currentChange"
					background layout="prev, pager, next">
				</el-pagination>
			</div>
		</div>

		<emptyPage v-else-if="isFinish&&dataList.length==0" :title="langInfo.no_data_available">
		</emptyPage>
	</div>
</template>

<script>
	import emptyPage from '@/components/emptyPage.vue'
	export default {
		components: {
			emptyPage
		},
		data() {
			return {
				total: 0,
				page: 1,
				limit: 8,
				isFinish: false,
				dataList: [],
				langInfo: {}
			}
		},
		mounted() {
			this.langInfo = this.$store.getters['lang/getLangList']
			if (this.langInfo.length == 0) {
				this.getdict_data()
			}
			this.get_myCollection()
		},
		methods: {
			getdict_data() {
				this.$api.dict_data({}).then((res) => {
					console.log(res);
					const obj = {}
					res.data.forEach((item, index) => {
						obj[item.key] = item.value
					})
					this.langInfo = obj

					this.$store.dispatch('lang/setLangList', obj)
				}).catch((error) => {})
			},
			goUrl(item, index) {
				this.$router.push({ path: '/resourceDetail', query: { id: item.info.id } })
			},
			currentChange(e) {
				console.log(e);
				this.page = e
				this.get_myCollection()
			},
			get_myCollection() {
				// type=类型:1=资讯,2=资源,3=宝贝
				this.$api.myCollection({
					type: 2,
					page: this.page,
					limit: this.limit
				}).then((res) => {
					console.log(res);
					this.isFinish = true
					this.dataList = res.data.list
					this.total = res.data.total
				}).catch((error) => {
					this.$message({
						message: error.msg,
						type: 'warning'
					})
				})
			},
			cancelCollect(item, index) {
				let that = this
				this.$confirm('确定取消收藏吗?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.news_resource_like({
						fid: item.info.id,
						type: 2, //1=资讯,2=资源,3=宝贝
						is_l: 2 //1=点赞,2=收藏
					}).then((res) => {
						console.log(res);
						this.$message({
							message: res.msg,
							type: 'warning'
						})
						that.dataList.splice(index, 1)
					}).catch((error) => {
						this.$message({
							message: error.msg,
							type: 'warning'
						})
					})

				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});


			}


		}
	}
</script>

<style>
</style>